<template>
	<div class="task-view">
		<div class="header">
			<div class="label">
				<div class="primary">Spartan Software ApS</div>
				<div class="secondary">Nicolaj Andersen</div>
			</div>
			<div :class="['due', getColor(5)]">5</div>
		</div>
		<div class="tasks">
			<div class="task">Dette er en lang besrkivelse af en ophgave, så den ikke kans tå på det lille felt</div>
		</div>
	</div>
</template>

<script>
	export default {
		methods: {
			getColor(due) {
				if (due > 0) 	return 'green';
				if (due == 0) 	return 'yellow';
				if (due < 0) 	return 'red';
			}
		}
	}
</script>

<style lang="scss" scoped>
	.task-view {
		box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);

		background-color: white;
		overflow: hidden;
		margin-bottom: 20px;
		border-radius: 5px;

		& > .header {
			display: grid;
			grid-template-columns: 1fr 50px;

			& > .label {
				padding: 8px 0 0 8px;

				& > .primary {
					font-size: 14px;
					font-weight: bold;
				}

				& > .secondary {
					font-size: 12px;
				}
			}

			& > .due {
				font-weight: bold;
				line-height: 50px;
				text-align: center;
				color: white;
				
				&.green {
					background-color: green;
				}

				&.yellow {
					background-color: rgb(224, 183, 0);
				}

				&.red {
					background-color: rgb(124, 0, 0);
				}
			}
		}

		& > .tasks {
			& > .task {
				border-top: 1px solid #cecece;
				font-size: 12px;
				padding: 8px;
			}
		}
	}
</style>